import { Route, Switch } from 'react-router-dom';

import AllNotesPage from './pages/AllNotes';
import NewNotePage from './pages/NewNote';
import FavoritesPage from './pages/Favorites';
import Layout from './layout/Layout';


function App() {
  return (
    <Layout>
      <Switch>
      <Route path='/' exact>
        <AllNotesPage />
      </Route>
      <Route path='/new-note'>
        <NewNotePage />
      </Route>
      <Route path='/favorites'>
        <FavoritesPage />
      </Route>
      </Switch>
    </Layout>
  );
}

export default App;
